import React from 'react';
import transportBoxImg from '../assets/transport-box.png';
import giftBoxImg from '../assets/gift-box.png';

// Бэкап-картинки для legacy-типов до загрузки API или если image_url отсутствует.
const LEGACY_IMG = {
  transport: transportBoxImg,
  gift: giftBoxImg,
};

const API_BASE = (typeof window !== 'undefined' && window.location)
  ? window.location.origin
  : '';

function resolveImageSrc(item) {
  if (item.image_url) {
    // image_url приходит как "/uploads/packaging/transport.webp?v=..." — относительный путь
    return item.image_url.startsWith('http') ? item.image_url : `${API_BASE}${item.image_url}`;
  }
  return LEGACY_IMG[item.type] || LEGACY_IMG.transport;
}

function PackagingSelector({ packagingList, selectedType, packagingAvailability, onSelect }) {
  // Если API ещё не отдал список — используем legacy hardcode.
  // После загрузки — берём из API (с актуальными name + image_url + sort_order).
  const items = (packagingList && packagingList.length > 0)
    ? packagingList
    : [
        { type: 'transport', name: 'Фирменный бокс', image_url: null, quantity: 1 },
        { type: 'gift', name: 'Подарочный бокс', image_url: null, quantity: 1 },
      ];

  return (
    <div className="checkout-field">
      <label>Упаковка</label>
      <div
        className="delivery-type-options"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10px',
        }}
      >
        {items.map((opt) => {
          const available = packagingAvailability[opt.type]?.available !== false;
          const label = opt.name || opt.type;
          const imgSrc = resolveImageSrc(opt);
          return (
            <label
              key={opt.type}
              className={`delivery-type-option ${selectedType === opt.type ? 'active' : ''} ${!available ? 'disabled' : ''}`}
              style={{
                padding: '10px',
                cursor: available ? 'pointer' : 'not-allowed',
                opacity: available ? 1 : 0.5,
              }}
            >
              <input
                type="radio"
                name="packaging_type"
                value={opt.type}
                checked={selectedType === opt.type}
                onChange={(e) => onSelect(e.target.value)}
                disabled={!available}
                style={{ display: 'none' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                <div style={{
                  width: '110px',
                  height: '110px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                }}>
                  <img
                    src={imgSrc}
                    alt={label}
                    style={{ width: '110px', height: '110px', objectFit: 'contain' }}
                  />
                </div>
                <span style={{ fontSize: '12px', textAlign: 'center', lineHeight: '1.2' }}>
                  {label}
                  {!available && (
                    <span style={{ display: 'block', color: '#f44336', fontSize: '10px', marginTop: '2px' }}>
                      Нет в наличии
                    </span>
                  )}
                </span>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default PackagingSelector;
